import { PagedMultiSelectField, laravelServiceSelectFetchConfig } from "@dgs/core";
import { FC } from "react";
import { eventTypeService } from "../api/eventTypeService";

interface Props {
	name: string;
	label: string;
	required?: boolean;
	disabled?: boolean;
}

const fetchConfig = laravelServiceSelectFetchConfig(eventTypeService);

export const EventTypeMultiSelectField: FC<Props> = ({ name, label, required, disabled }) => {
	return (
		<PagedMultiSelectField
			name={name}
			label={label}
			fetchConfig={fetchConfig}
			clearable={true}
			required={required}
			disabled={disabled}
			compare={(first, second) => first.id === second.id}
		/>
	);
};
